import Link from 'next/link'

/**
 * Small pieces shared by the routes that have no reference file of their
 * own and borrow the closest one (styles in ../misc-pages.css). Markup and
 * class names are the reference's: the `.arrow` glyph inside `.btn`, the faq
 * `.plus` glyph, and the blog post hero.
 */

/** The reference button arrow (→ by default, ↓ with `down`). */
export function RefArrow({ down = false }: { down?: boolean }) {
  return (
    <svg
      className='arrow'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      aria-hidden='true'
    >
      <path d={down ? 'M12 5v14M6 13l6 6 6-6' : 'M5 12h14M13 6l6 6-6 6'} />
    </svg>
  )
}

/** The reference faq disclosure glyph (rotates to × when open). */
export function RefPlus() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      aria-hidden='true'
    >
      <path d='M12 5v14M5 12h14' />
    </svg>
  )
}

/**
 * The legal pages' hero in the blog post template (`.bhero`): eyebrow,
 * display title, lede and the contact button. Same copy, order and speakable
 * hooks (`data-hero-title` / `data-hero-description`) as the shared Hero it
 * replaces on these routes.
 */
export function LegalHero({
  eyebrow,
  title,
  description,
  ctaText,
  ctaHref,
}: {
  eyebrow: string
  title: string
  description: string
  ctaText: string
  ctaHref: string
}) {
  return (
    <>
      <div className='bhero__top'>
        <p className='eyebrow'>{eyebrow}</p>
      </div>
      <div className='lg-hero'>
        <h1 className='h-display h1' data-hero-title=''>
          {title}
        </h1>
        <div className='bhero__copy'>
          <p className='lede' data-hero-description=''>
            {description}
          </p>
          <div className='hero__cta'>
            <Link className='btn btn--accent' href={ctaHref}>
              {ctaText}
              <RefArrow />
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
